import { render } from "./HomeTemplate.vue?vue&type=template&id=f38f230a&scoped=true"
import script from "./HomeTemplate.vue?vue&type=script&lang=ts"
export * from "./HomeTemplate.vue?vue&type=script&lang=ts"

import "./HomeTemplate.vue?vue&type=style&index=0&id=f38f230a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f38f230a"

export default script